<template>
  <Layout>
    <q-card class="flexbox" style="margin-top:55px;position:relative">
      <div class="profile-header">
        <div class="profile-header-title" style="color:#000;font-weight:700">Mileage</div>
        <div class="profile-header-icons" v-if="$q.screen.gt.sm">
          <q-btn color="red" round @click="$store.commit('millage/SET_ADD',true)">
            <q-icon color="white" name="fas fa-plus" size="15px" class="cursor-pointer"></q-icon>
          </q-btn>
        </div>
      </div>
      <div class="profile-content">
        <div style="width:100%">
          <loading v-if="millages.length == 0 && loading"></loading>
          <empty-value
            description="If you want to add millage record please hit the button."
            name="record"
            v-if="millages.length == 0 && !loading"
          ></empty-value>
          <div v-else class="location-container">
            <millage
              v-for="(item, index) in millages"
              :index="index"
              :millage="item"
              :key="item.id"
            ></millage>
          </div>
        </div>
      </div>
      <millage-add></millage-add>
      <millage-confirm></millage-confirm>
      <millage-edit></millage-edit>
    </q-card>
  </Layout>
</template>

<script>
import axios from "../axios/index";
import Layout from "../components/Layout";
import Confirm from "../components/Confirm";
import Loading from "../components/Loading";
import EmptyValue from "../components/EmptyValue";
import Millage from "../components/Millage";
import MillageAdd from "../components/MillageAdd";
import MillageEdit from "../components/MillageEdit";
import MillageConfirm from "../components/MillageConfirm";
export default {
  metaInfo() {
    return {
      title:
        "Adjustment page for Mileage and MMR information regarding on Current Fleet | FMS",
      // title: "FMS - Build your network in your field of interest",
      meta: [
        {
          name: "description",
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: "",
        },
        {
          property: "og:title",
          content:
            "Adjustment page for Mileage and MMR information regarding on Current Fleet | FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  components: {
    MillageEdit,
    MillageConfirm,
    MillageAdd,
    Loading,
    EmptyValue,
    Confirm,
    Layout,
    Millage: () => import("../components/Millage"),
  },
  methods: {
    async getMillages(vehicleId) {
      this.millages = [];
      this.loading = true;
      const params = { vehicle_id: vehicleId };
      this.search !== "" ? (params.search = this.search) : "";
      const { data } = await axios.get(`vehicle-mileage-records`, { params });
      this.millages = data.data;
      this.loading = false;
    },
  },
  mounted(){
    this.$root.$on('reRequest',(id) => this.getMillages(id))
  },
  computed: {
    millages: {
      get() {
        return this.$store.state.millage.millages;
      },
      set(val) {
        this.$store.commit("millage/SET_MILLAGES", val);
      },
    },
    loading: {
      get() {
        return this.$store.state.millage.loading;
      },
      set(val) {
        this.$store.commit("millage/SET_LOADING", val);
      },
    },
    selectedVehicle() {
      return this.$store.state.millage.selectedVehicle;
    },
    search: {
      get() {
        return this.$store.state.millage.search;
      },
      set(val) {
        this.$store.commit("millage/SET_SEARCH", val);
      },
    },
  },
  watch: {
    search(n, o) {
      this.getMillages(this.selectedVehicle.id);
    },
    selectedVehicle: {
      deep: true,
      handler(n, o) {
        if (n && n.id) this.getMillages(n.id);
      },
    },
  },
};
</script>
